import TipoEspService from "@/services/TipoEspService";

import { bool } from "yup";
//this.$store.state.user.users,current_page
export const tipoEsp = {
    namespace:true,
    state: {tipoEsp:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListTipoesp({commit},pageNumber){
            return await TipoEspService.getlist(pageNumber).then(
                response=>{    
                    commit('setTipoesp',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListTipoesp({commit},search){          
            return await TipoEspService.getSearch(search).then (
                response =>{                    
                    commit('setTipoesp',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setTipoesp(state,data){
        state.tipoEsp = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.tipoEsp.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};